<script setup>
import { WalletMultiButton } from "solana-wallets-vue";
</script>

<template>
    <wallet-multi-button></wallet-multi-button>
</template>
